<i18n>
{
  "no": {
    "doYouWantToLogOut": "Vil du logge ut?",
    "youWillBeRedirected": "Du vil bli omdirigert til {0}",
    "logOut": "Logg ut"
  },
  "en": {
    "doYouWantToLogOut": "Do you want to log out?",
    "youWillBeRedirected": "You will be redirected to {0}",
    "logOut": "Log out"
  }
}
</i18n>

<template>
  <InfoScreen>
    <TnHeading type="h1" size="m" class="margin-bottom-l">
      {{ t('doYouWantToLogOut') }}
    </TnHeading>
    <TnParagraph class="margin-bottom-l">
      {{ t('youWillBeRedirected', { 0: redirectTitle }) }}
    </TnParagraph>

    <TnButton secondary block href="/account/logout" target="_blank" :text="t('logOut')" />
  </InfoScreen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnButton, TnHeading, TnParagraph } from '@telenornorgeinternal/telegrafen-vue3-core';

import InfoScreen from '@/components/InfoScreen.vue';

const { t } = useI18n();

// Placeholder retained from the original implementation.
const redirectTitle = 'Title/Url here';
</script>
